import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const languages = {
    en: { flag: "🇬🇧", name: "English", short: "EN" },
    ms: { flag: "🇲🇾", name: "Bahasa Melayu", short: "BM" },
    zh: { flag: "🇨🇳", name: "中文", short: "中" },
  };

  const handleLanguageChange = (code) => {
    i18n.changeLanguage(code);
    setIsOpen(false);
  };

  return (
    <div className="absolute top-[6px] right-[6px] z-50">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-1 px-1 rounded-lg bg-white/10 hover:bg-white/20 transition-colors duration-200"
        aria-label={t("common.change_language")}
      >
        <FontAwesomeIcon icon={faGlobe} className="w-4 h-4 text-gray-200" />
        <span className="text-base font-semibold text-gray-200">
          {languages[i18n.language].short}
        </span>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-32 rounded-lg bg-gray-800 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none overflow-hidden">
          <div className="py-1" role="menu" aria-orientation="vertical">
            {Object.entries(languages).map(([code, { flag, name }]) => (
              <button
                key={code}
                onClick={() => handleLanguageChange(code)}
                className={`flex items-center gap-2 w-full px-3 py-1.5 text-sm font-semibold ${
                  i18n.language === code
                    ? "bg-gray-700 text-white"
                    : "text-white hover:bg-gray-700"
                } transition-colors duration-150`}
                role="menuitem"
              >
                <span className="text-lg">{flag}</span>
                <span className="text-sm text-white">{name}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
